module.exports = __webpack_public_path__ + "assets/PaymentMethod.29e6a995.svg";